module.exports = __webpack_public_path__ + "static/media/flowers_11.d68e201f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_11.csv
// module id = 750
// module chunks = 0